import { render, staticRenderFns } from "./WorkflowStateThresholdsGroupList.vue?vue&type=template&id=c71ff5d2&"
import script from "./WorkflowStateThresholdsGroupList.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStateThresholdsGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports